import React from 'react'
import { Navigate } from 'react-router-dom'

import { useAuthStore } from '@/stores/authStore'

// 受保护的路由组件
export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuthStore()
  return isAuthenticated ? <>{children}</> : <Navigate to="/auth" replace />
}

// 登录路由组件
export const LoginRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuthStore()
  return isAuthenticated ? <Navigate to="/" replace /> : <>{children}</>
}